import { Component, Input, Output, EventEmitter, HostListener, ChangeDetectionStrategy } from '@angular/core';
import { NgClass, NgIf } from '@angular/common';
import { TitanIconComponent } from '../titan-icon/titan-icon.component';

@Component({
  selector: 'app-titan-menu-item',
  templateUrl: './titan-menu-item.component.html',
  styleUrls: ['./titan-menu-item.component.scss'],
  standalone: true,
  imports: [NgClass, NgIf, TitanIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TitanMenuItemComponent {
  @Input() disabled: boolean = false;
  @Input() selected: boolean = false;
  @Input() hasSubmenu: boolean = false;
  @Input() isDestructive: boolean = false;
  @Input() href: string = '';

  @Output() menuItemClick = new EventEmitter<Event>();

  get menuItemClasses(): { [key: string]: boolean } {
    return {
      'menuItem': true,
      'body-m-500': true
    };
  }

  get dataAttributes(): { [key: string]: string | null } {
    return {
      'data-disabled': this.disabled ? 'true' : null,
      'data-selected': this.selected ? 'true' : null,
      'data-has-submenu': this.hasSubmenu ? 'true' : null,
      'data-is-destructive': this.isDestructive ? 'true' : null
    };
  }

  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    if (!this.disabled) {
      this.menuItemClick.emit(event);
    }
  }
}
